export default __webpack_public_path__ + "static/media/bg-monitoring-2.10590762.png";